@if (buildVersion.staleBundleDetected()) {
  <div class="staleBundleBanner" role="status">
    <span class="staleBundleBanner-text">
      A new version of this app is available.
    </span>
    <app-weave-button
      text="Reload"
      classes="secondary staleBundleBanner-reload"
      (clicked)="reloadWithConfirmation()"
    ></app-weave-button>
  </div>
}
